import { Action } from '../../../actions';
import { REMOVE_BANNER_IMAGE } from '../../../actions/banners-edit/banner-text-image';
import {
    ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    UPDATE_MASS_ACTIONS_IMAGE_CREATIVE
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import {
    BannersEditMassActionsState,
    MassActionId
} from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionImageCreativeReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: Action,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        case OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        imageBulkCreativeReplacementEditorVisible: true
                    }
                }
            };
        case UPDATE_MASS_ACTIONS_IMAGE_CREATIVE:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        imageCreative: action.creative
                    }
                }
            };
        case REMOVE_BANNER_IMAGE: {
            if (action.bannerId === MassActionId.bannersEdit) {
                return {
                    ...state,
                    [action.bannerId]: {
                        ...state[action.bannerId],
                        data: {
                            ...state[action.bannerId].data,
                            imageCreative: []
                        }
                    }
                };
            } else {
                return state;
            }
        }
        default:
            return state;
    }
}
